import { Card, CardContent, CardHeader, Divider, SingleInfoCard } from '@forgeglobal/design-framework'
import { transformHoldingFragment } from 'components/holdings/HoldingUtils'
import { useHoldingQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

const HoldingCard: React.FC<{ holdingId: number }> = ({ holdingId }) => {
  const { data } = useHoldingQuery({ variables: { id: holdingId } })
  const holding = data?.holding
  const holdingData = holding && transformHoldingFragment(holding)
  return (
    <Card>
      <CardHeader title="Related Holding" />
      <Divider />
      <CardContent>{holdingData && <SingleInfoCard {...holdingData} />}</CardContent>
    </Card>
  )
}

export { HoldingCard }
